import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { pxToRem } from './utilities'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart

export const initLenis = () => {
  const header = document.querySelector('.header__inner')
  const logo = document.querySelector('.header__home')

  lenis = new Lenis({
		anchors: {
			offset: -118,
			duration: 1.8
		}
  })

	lenis.on('scroll', ScrollTrigger.update())

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)

    if (lenis.scroll > 200) {
      document.documentElement.dataset.scrolled = true

			let totalWidth = 36

      const headerChildren = document.querySelectorAll('.header__home, .header__nav')

      headerChildren.forEach((child) => {
        const style = window.getComputedStyle(child)
        const width = child.offsetWidth
        const marginLeft = parseFloat(style.marginLeft)
        const marginRight = parseFloat(style.marginRight)
        totalWidth += width + marginLeft + marginRight
      })

      header.style.width = `${pxToRem(totalWidth)}rem`
    } else {
      document.documentElement.dataset.scrolled = false
      header.style.width = `${pxToRem(header.dataset.width)}rem`
    }
  }

  scrollTo()
  requestAnimationFrame(raf)

}

export const scrollTo = () => {
  const links = document.querySelectorAll('[data-scroll-to]')

  if (!links) return

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const target = link.getAttribute('data-scroll-to')
      const offset = link.getAttribute('data-scroll-offset')
      const targetEl = document.querySelector(target)
      lenis.scrollTo(targetEl, {
        duration: 1.5,
        offset: offset ? Number(offset) : 0,
        easing: (x) => {
          return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
        },
      })
    })
  })
}

scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true })
}

export default () => {}